import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Only scroll to top if there's no hash in the URL
    // This prevents interfering with hash navigation
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
};

export default useScrollToTop;
